import { Controller } from "@hotwired/stimulus"
import initializeBootstrapTooltips from '../scripts/tooltips';
import initializeClickTracking from '../scripts/click-tracking.js';
import initializeMaxCharacterTracking from '../scripts/character-tracking.js';

export default class extends Controller {

  connect() {

    // TODO these can be replaced with stimulus controllers in the future
    initializeBootstrapTooltips();
    initializeClickTracking();
    initializeMaxCharacterTracking();

    console.clear();

    const fanword = String.raw`
           :::::::::::::::::::::::::::::::::     ::::::::::::::::::::::::::::::::::::
          ::::::::::::::::::::::::::::::::::         ::::::::::::::::::::::::::::::::::
         ::::::::::::::::::::::::::::::::::             :::::::::::::::::::::::::::::::::
         :::::::::::::::::::::::::::::::::                 ::::::::::::::::::::::::::::::
         ::::::::::::::::::::::::::::::::                     :::::::::::::::::::::::::::
         :::::::::::::::::::::::::::::::                         ::::::::::::::::::::::::
         :::::::::::::::::::::::::::::                              :::::::::::::::::::::
         ::::::::::::::::::::::::::::                                  ::::::::::::::::::
         :::::::::::::::::::::::::::                                      :::::::::::::::
         ::::::::::::::::::::::::::               :::                   :::::::::::::::::
         :::::::::::::::::::::::::               :::::::               ::::::::::::::::::
         ::::::::::::::::::::::::               :::::::::::           :::::::::::::::::::
         :::::::::::::::::::::::               :::::::::::::::       ::::::::::::::::::::
         ::::::::::::::::::::::               ::::::::::::::::::::  :::::::::::::::::::::
         :::::::::::::::::::::                   ::::::::::::::::::::::::::::::::::::::::
         ::::::::::::::::::::                       :::::::::::::::::::::::::::::::::::::
         :::::::::::::::::::                           ::::::::::::::::::::::::::::::::::
         ::::::::::::::::::                               :::::::::::::::::::::::::::::::
         ::::::::::::::::                                    ::::::::::::::::::::::::::::
         :::::::::::::::                                     ::::::::::::::::::::::::::::
         ::::::::::::::               :::::                 :::::::::::::::::::::::::::::
         :::::::::::::               :::::::::             :::::::::::::::::::::::::::::
         ::::::::::::               ::::::::::::::       ::::::::::::::::::::::::::::::
         :::::::::::               :::::::::::::::::     :::::::::::::::::::::::::::
         ::::::::::
         :::::::::
         ::::::::
         :::::::
         ::::::
         :::::
         ::::
         :::
         :
    `;

    console.log(fanword);
  }

}

